import { ClientCommunicator } from "@alme/post-message-api/ClientCommunicator";
const clientCommunicators = [];
function getClientCommunicator(allowedOrigins, source) {
    let clientCommunicatorMap = clientCommunicators.find(c => c.source === source);
    if (!clientCommunicatorMap) {
        clientCommunicatorMap = {
            source,
            clientCommunicator: new ClientCommunicator(allowedOrigins, source),
        };
        clientCommunicators.push(clientCommunicatorMap);
    }
    return clientCommunicatorMap.clientCommunicator;
}
export { getClientCommunicator };
